import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProcessImprovementsView } from "src/components/views/spc/processImprovement/ProcessImprovementsView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/spc/processImprovements")({
	staticData: { title: i18n.t("explanations"), legacyViewKey: "processImprovementsView" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <ProcessImprovementsView isActive={isActive} />;
}
